import { gql } from '$lib/apollo';

export const ADD_PAYMENT_METHOD = gql`
  mutation AddPaymentMethod($input: BillingCreateInput!) {
    billingCreate(input: $input) {
      result {
        type
      }
      errors {
        ... on Error {
          message
          code
        }
        ... on ThreeDSecureError {
          code
          token
        }
      }
    }
  }
`;

export const REMOVE_PAYMENT_METHOD = gql`
  mutation RemovePaymentMethod {
    billingDelete {
      result {
        id
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`;
